import { connect } from 'react-redux'
import { authActions } from 'store/user'
import noticeActions from 'store/notice'
import Login from '../components/LoginPage'
import { actions } from '../modules/Login'

const mapStateToProps = state => {
  const { login, strings, modal, user } = state
  const { LANDING_MESSAGE_ENABLED, IS_POSITIVE_MESSAGE } = process.env

  return {
    ...login,
    strings,
    modalProps: modal,
    isPositiveMessage: IS_POSITIVE_MESSAGE === 'YES',
    landingMessage: LANDING_MESSAGE_ENABLED === 'YES',

    humiIsabellaDisabled:
      user?.study?.config?.is_rewardless_study &&
      user?.study?.config?.is_avatarless_study
  }
}

const mapDispatchToProps = Object.assign({}, actions, {
  login: authActions.login,
  openNotice: modalProps => noticeActions.openNotice(modalProps)
})

export default connect(mapStateToProps, mapDispatchToProps)(Login)
